<script setup>
import { useStore } from 'vuex'
import { computed } from 'vue'
import dayjs from 'dayjs'
import { PAST_DUE_DAYS_LIMIT } from '@/constants'

const store = useStore()
const isPastDue = computed(() => store.getters['workspace/billing/isPastDue'])
const isPaused = computed(() => store.getters['workspace/billing/isPaused'])
const isUnpaid = computed(() => store.getters['workspace/billing/isUnpaid'])
const isInactive = computed(() => store.getters['workspace/billing/isInactive'])
const isFrozen = computed(() => store.getters['workspace/isFrozen'])
const lastWorkspaceInvoiceUrl = computed(() => store.getters['subscription/lastWorkspaceInvoiceUrl'])
const lastWorkspaceReceiptUrl = computed(() => store.getters['subscription/lastWorkspaceReceiptUrl'])
const currentPeriodStarts = computed(() => store.getters['workspace/billing/currentPeriodStarts'])
const pastDueDays = computed(()=>{
  if (!currentPeriodStarts.value || !isPastDue.value) return null
  const currentPeriodStartsDate = dayjs(currentPeriodStarts.value).add(PAST_DUE_DAYS_LIMIT, 'day')
  const currentDate = dayjs()
  return currentPeriodStartsDate.diff(currentDate, 'days')
})

</script>

<template>
  <a-typography-title
    :level="5"
    style="margin-bottom: 20px;"
  >
    {{ $t('components.subscriptionSettings.manageSubscription') }}
  </a-typography-title>
  <a-alert
    v-if="isPastDue"
    show-icon
    type="warning"
    style="margin-bottom: 16px;"
  >
    <template #message>
      {{ $t('components.subscriptionSettingsManageBlockEnterprise.lastPaymentFailEnterprize', {days: pastDueDays}, pastDueDays) }}
      <br>
      <a-typography-link
        class="underline-link"
        href="mailto:support@kitcast.tv"
      >
        {{ $t('components.subscriptionSettings.contactSupportLink') }}
      </a-typography-link>
    </template>
  </a-alert>
  <a-alert
    v-else-if="isUnpaid"
    show-icon
    type="warning"
    style="margin-bottom: 16px;"
  >
    <template #message>
      {{ $t('components.subscriptionSettingsManageBlockEnterprise.subscriptionSuspendedEnterprize') }}
      <br>
      <a-typography-link
        class="underline-link"
        href="mailto:support@kitcast.tv"
      >
        {{ $t('components.subscriptionSettings.contactSupportLink') }}
      </a-typography-link>
    </template>
  </a-alert>
  <a-alert
    v-else-if="isPaused"
    show-icon
    type="warning"
    style="margin-bottom: 16px;"
  >
    <template #message>
      {{ $t('components.subscriptionSettings.subscriptionPaused') }}
      <br>
      <a-typography-link
        class="underline-link"
        href="mailto:support@kitcast.tv"
      >
        {{ $t('components.subscriptionSettings.contactSupportLink') }}
      </a-typography-link>
    </template>
  </a-alert>
  <a-alert
    v-else-if="isInactive"
    show-icon
    type="warning"
    style="margin-bottom: 16px;"
  >
    <template #message>
      {{ $t('components.subscriptionSettingsManageBlockEnterprise.subscriptionDoesntExistEnterprize') }}
      <br>
      <a-typography-link
        class="underline-link"
        href="mailto:support@kitcast.tv"
      >
        {{ $t('components.subscriptionSettings.contactSupportLink') }}
      </a-typography-link>
    </template>
  </a-alert>
  <a-alert
    v-else-if="isFrozen"
    show-icon
    type="warning"
    style="margin-bottom: 16px;"
  >
    <template #message>
      {{ $t('components.subscriptionSettings.subscriptionFrozen') }}
      <br>
      <a-typography-link
        class="underline-link"
        href="mailto:support@kitcast.tv"
      >
        {{ $t('components.subscriptionSettings.contactSupportLink') }}
      </a-typography-link>
    </template>
  </a-alert>
  <a-space
    direction="vertical"
  >
    <a-typography-link
      :disabled="!lastWorkspaceInvoiceUrl"
      download
      :href="lastWorkspaceInvoiceUrl"
    >
      {{ $t('components.subscriptionSettings.downloadLatestInvoiceLink') }}
    </a-typography-link>
    <a-typography-link
      :disabled="!lastWorkspaceReceiptUrl"
      download
      :href="lastWorkspaceReceiptUrl"
    >
      {{ $t('components.subscriptionSettings.downloadLatestReceiptLink') }}
    </a-typography-link>
  </a-space>
  <div style="margin-top: 16px;">
    {{ $t('components.subscriptionSettings.contactUsToChangeSubscription') }} <a-typography-link href="mailto:support@kitcast.tv">
      support@kitcast.tv
    </a-typography-link>
  </div>
</template>

<style scoped lang="less">

</style>

